/**
 * In-page warm-up for block images lazysizes cannot or will not reach in time:
 *
 * - Team detail panels (block-team): display:none until a name is tapped, and
 *   lazysizes skips hidden elements entirely — without this, the first open
 *   of every panel blur-flashes, especially in the mobile accordion.
 * - Contact map (block-contact-map): in flow, but warming it here puts it
 *   deterministically behind project imagery instead of wherever
 *   preloadAfterLoad's sweep happens to reach it.
 *
 * The images already carry their real candidates in data-srcset/sizes —
 * copying both onto a detached probe makes the browser pick exactly what the
 * revealed <img> will request (same viewport, same DPR). Casual bucket of the
 * shared warmQueue: the site-wide rule is project imagery first. After
 * load + idle, deferred while the page is only being prerendered, skipped on
 * Save-Data / slow connections.
 */
import { fastConnection } from './utils'
import { warmImage } from './warmQueue'

const IMAGES = '.team-member-detail img.lazyload, .block-contact-map img.lazyload'

if (fastConnection() && document.querySelector(IMAGES)) {
  const warm = () => {
    document.querySelectorAll(IMAGES).forEach((img) => {
      const srcset = img.getAttribute('data-srcset')
      if (srcset) warmImage({ srcset, sizes: img.getAttribute('sizes') || '' })
    })
  }

  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 300))
  const start = () => idle(warm)
  const whenLoaded = () => {
    if (document.readyState === 'complete') start()
    else window.addEventListener('load', start, { once: true })
  }

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', whenLoaded, { once: true })
  } else {
    whenLoaded()
  }
}
